import PropTypes from "prop-types";
import {
  Button,
  Col,
  Empty,
  Flex,
  message,
  Modal,
  Popover,
  Row,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import "./style.css";
import API from "../../services/api-request";
import SelectRack from "./SelectRack";

const SelectLayoutNew = ({ value, onChange, action }) => {
  const [selectedStorage, setSelectedStorage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [rackLocation, setRackLocation] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [rackData, setRackData] = useState(null);
  const [temporarySelected, setTemporarySelected] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const handleRackSelect = (rackData) => {
    onChange?.({ ...rackData, warehouse_name: selectedStorage.warehouse_name });
    setShowModal(false);
  };

  const handleOpenModal = (id, name, row, section, temporary) => {
    if (!name) return;

    const codifiedName = temporary
      ? "T-CS" + name.split(" ")[2]
      : "CS" + name.split(" ")[2];

    setReloadKey((prev) => prev + 1);
    setShowModal(true);
    setRackLocation(`${codifiedName}-${row}${section}`);
    setRackData({ id, name, row, section });
  };

  const getAreaData = (id = 1) => {
    setLoading(true);

    API.Get(`area/map`)
      .then((res) => {
        const data = res?.data || [];

        setSelectedStorage(data.find((item) => item.warehouse_id === id));
        setWarehouses(
          data.map((item) => ({
            id: item.warehouse_id,
            warehouse_name: item.warehouse_name,
          })),
        );
      })
      .catch((err) => {
        console.log(err);
        message.error("Failed to fetch area data!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAreaData();
  }, []);

  const renderSectionButtons = (row, isTemp) =>
    row?.sections?.map((section, sIdx) => {
      const totalAreas =
        +section?.empty_areas + +section?.occupied_areas;
      const ratio = `${section?.occupied_areas}/${totalAreas}`;

      return (
        <Col
          key={section?.section || sIdx}
          span={row?.sections?.length > 1 ? 12 : 24}
        >
          <Button
            color="primary"
            variant="outlined"
            className="section-button"
            onClick={() => {
              handleOpenModal(
                selectedStorage?.warehouse_id,
                selectedStorage?.warehouse_name,
                row?.row_number,
                section?.section,
                isTemp,
              );
            }}
          >
            <div>
              {section?.section}
              <br />
              {ratio}
              <div>{Math.round(section?.total_weight)} Kg</div>
            </div>
          </Button>
        </Col>
      );
    });

  const renderStorageContent = () => {
    if (loading) {
      return (
        <Flex
          justify="center"
          align="center"
          style={{ marginTop: "10rem", marginBottom: "10rem" }}
        >
          <Spin size="large" />
        </Flex>
      );
    }

    if (!selectedStorage?.rows?.length) {
      return (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ marginTop: "10rem" }}
        />
      );
    }

    const isTemp = Boolean(
      selectedStorage?.warehouse_name?.includes("Temporary")
    );

    return (
      <Row gutter={8}>
        {selectedStorage?.rows.map((row, rIdx) => (
          <Col span={4} key={row?.row_number || rIdx}>
            <Flex justify="center">
              <div>
                <h2 style={{ textAlign: "center" }}>{row?.row_number}</h2>
                <Row gutter={4}>{renderSectionButtons(row, isTemp)}</Row>
              </div>
            </Flex>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <>
      <Flex gap={8}>
        {warehouses.map(
          (item) =>
            !item.warehouse_name.includes("Temporary") && (
              <Button
                variant={
                  selectedStorage?.warehouse_name === item?.warehouse_name
                    ? "solid"
                    : "outlined"
                }
                color="primary"
                style={{
                  borderRadius: 20,
                  padding: "1rem",
                }}
                key={item.id}
                onClick={() => {
                  setTemporarySelected(false);
                  getAreaData(item?.id);
                }}
              >
                {item?.warehouse_name}
              </Button>
            ),
        )}
        <Popover
          content={
            <Row gutter={8}>
              {warehouses.map(
                (item) =>
                  item.warehouse_name.includes("Temporary") && (
                    <Col span={8} key={item.id}>
                      <Button
                        variant={
                          selectedStorage?.warehouse_name ===
                          item?.warehouse_name
                            ? "solid"
                            : "outlined"
                        }
                        color="primary"
                        style={{
                          borderRadius: 20,
                          padding: "1rem",
                        }}
                        onClick={() => {
                          setTemporarySelected(true);
                          getAreaData(item?.id);
                        }}
                      >
                        {item?.warehouse_name}
                      </Button>
                    </Col>
                  ),
              )}
            </Row>
          }
        >
          <Button
            variant={temporarySelected ? "solid" : "outlined"}
            color="primary"
            style={{
              borderRadius: 20,
              padding: "1rem",
            }}
          >
            Temporary Area
          </Button>
        </Popover>
      </Flex>
      {renderStorageContent()}

      <Modal
        title={rackLocation}
        closeIcon={false}
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width={"40%"}
      >
        <SelectRack
          data={rackData}
          location={rackLocation}
          onRackSelect={handleRackSelect}
          action={action}
          open={showModal}
          reloadKey={reloadKey}
        />
      </Modal>
    </>
  );
};


SelectLayoutNew.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  action: PropTypes.any,
};

export default SelectLayoutNew;
